import { FormattedMessage } from 'react-intl'
import {OnlineToolsListToolbar} from './OnlineToolsListToolbar'

const OnlineToolsListHeader = () => {

  return (
    <div className='card-header border-0 pt-6'>
      <h2 className='fw-bolder'>{<FormattedMessage id ="ONLINE.TOOLS.LIST"/>}</h2>
      {/* <ParametersListSearchComponent /> */}
      {/* begin::Card toolbar */}
      <div className='card-toolbar'>
        {/* begin::Group actions */}
        {<OnlineToolsListToolbar />}
        {/* end::Group actions */}
      </div>
      {/* end::Card toolbar */}
    </div>
  )
}

export {OnlineToolsListHeader}
